
import React from 'react';

interface ChangeBackgroundIconProps extends React.SVGProps<SVGSVGElement> {}

const ChangeBackgroundIcon: React.FC<ChangeBackgroundIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 11.25l.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21.75 11.25l-.041-.02a.75.75 0 0 0-1.063.852l.708 2.836a.75.75 0 0 1-1.063.853l-.041-.021M12 2.25v.008M12 3.75a.375.375 0 1 1 0-.75.375.375 0 0 1 0 .75zM12 20.25v.008m0 .008a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75z" />
     {/* Person with a dashed or different background indicator */}
  </svg>
);

export default ChangeBackgroundIcon;
